import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "row bt-dash" }
const _hoisted_2 = { class: "col-12 p-0" }
const _hoisted_3 = {
  class: "w-100 table",
  style: {"border-collapse":"collapse"}
}
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "d-flex justify-content-center align-items-center gap-2 form-check checkbox-checked" }
const _hoisted_6 = ["id", "onUpdate:modelValue"]
const _hoisted_7 = ["for"]
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = ["onUpdate:modelValue"]

import { computed, watch, ref } from 'vue'
import { useProductsStore } from '@/store/management/productsStore';
import type { Product, PriceLevel } from '@/store/management/productsStore';

import { useI18n } from 'vue-i18n'
import { productPriceLevelsLanguage } from '@/core/locales/products-language'

const MAX_PRICE_LEVELS = 9;


export default /*@__PURE__*/_defineComponent({
  __name: 'productPriceLevels',
  setup(__props) {

const { t } = useI18n({
  messages: productPriceLevelsLanguage
})

const productStore = useProductsStore()
const tempActiveProduct = computed(() => {
    return productStore.getTempActiveProduct
})

const activeProductId = computed(() => {
    return productStore.getActiveProductId
})

const activeProduct = computed(() => {
    return productStore.getActiveProduct
})

const createDefaultPriceLevel = (id: number): PriceLevel => ({
    id: id,
    priceEnable: false,
    priceLevel: 'Regular',
    price: 0,
    HALO: 0,
    LALO: 0,
});

const priceLevels = ref<PriceLevel[]>(
    Array.from({ length: 3 }, (_, i) => createDefaultPriceLevel(i + 1))
);

const addPriceLevel = () => {
    if (priceLevels.value.length < MAX_PRICE_LEVELS) {
        const newId = priceLevels.value.length + 1;
        priceLevels.value.push(createDefaultPriceLevel(newId));
    }
};

watch(activeProductId, (newVal) => {
    if (newVal) {
        const productGroup = activeProduct.value
        if (productGroup && Array.isArray(productGroup.priceLevels)) {
            priceLevels.value = productGroup.priceLevels.map((pl: PriceLevel, idx: number) => ({
                ...createDefaultPriceLevel(idx + 1),
                ...pl,
                id: pl.id ?? idx + 1,
            }));
        }
    }
}, { immediate: true });

watch(priceLevels, (newVal) => {
    productStore.setTempActiveProduct({
        ...tempActiveProduct.value,
        priceLevels: newVal,
    } as Product)
}, { deep: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_4, _toDisplayString(_unref(t)('Level')), 1),
            _createElementVNode("th", null, _toDisplayString(_unref(t)('Price')), 1),
            _createElementVNode("th", null, _toDisplayString(_unref(t)('HALO')), 1),
            _createElementVNode("th", null, _toDisplayString(_unref(t)('LALO')), 1)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(priceLevels.value, (priceLevel) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: priceLevel.id
            }, [
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_5, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: `checkbox-${priceLevel.id}`,
                    "onUpdate:modelValue": ($event: any) => ((priceLevel.priceEnable) = $event),
                    class: "form-check-input"
                  }, null, 8, _hoisted_6), [
                    [_vModelCheckbox, priceLevel.priceEnable]
                  ]),
                  _createElementVNode("label", {
                    for: `checkbox-${priceLevel.id}`,
                    style: {"margin-top":"12px"}
                  }, _toDisplayString(priceLevel.id) + ".", 9, _hoisted_7)
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  class: "w-100",
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((priceLevel.price) = $event)
                }, null, 8, _hoisted_8), [
                  [_vModelText, priceLevel.price]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  class: "w-100",
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((priceLevel.HALO) = $event)
                }, null, 8, _hoisted_9), [
                  [_vModelText, priceLevel.HALO]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  class: "w-100",
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((priceLevel.LALO) = $event)
                }, null, 8, _hoisted_10), [
                  [_vModelText, priceLevel.LALO]
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})